import Collection from '@/components/Collection'
import CreateUser from '@/pages/user/CreateForm'
import UpdateUser from '@/pages/user/EditForm'
import DeleteUser from '@/pages/user/DeleteForm'
import access from "../access";

export default {

  'user.collection': {
    path: '/admin/users',
    name: 'user.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listUsers",
      entity: "user",
      cols: [
        { label: "User ID", field: "user_id", sort: "id" },
        { label: "Registrar ID", field: "registrar_id", sort: "registrar" },
        { label: "Login name", field: "login_name" },
        { label: "Roles", html: (row) => row.roles.join(', ') }
      ],
      actions: (row) => {
        return [
          { name: "user.update", label: "edit", icon: "pencil2", params: {user_id: row.user_id} },
          { name: "user.delete", label: "delete", icon: "bin", params: {user_id: row.user_id} },
        ];
      }
    },
    meta: {
      access: access.admin,
      title: "User list",
      side_menu: { label: "Users",  icon: "users" },
      local_actions: [
        { name: "user.create", label: "Create user", color: "success", icon: "plus" }
      ]
    },
  },

  'user.create': {
    path: '/admin/users/create',
    name: 'user.create',
    component: CreateUser,
    meta: {
      access: access.admin,
      title: "Create new user"
    },
  },

  'user.update': {
    path: '/admin/users/update/:user_id',
    name: 'user.update',
    component: UpdateUser,
    props: (route) => {
      return {
        user_id: Number(route.params.user_id),
      }
    },
    meta: {
      access: access.admin,
      title: "Update user details",
      local_tasks: [
        { name: "user.update", label: "Edit"},
        { name: "user.delete", label: "Delete"}
      ]
    },
  },

  'user.delete': {
    path: '/admin/users/delete/:user_id',
    name: 'user.delete',
    component: DeleteUser,
    props: (route) => {
      return {
        user_id: Number(route.params.user_id),
      }
    },
    meta: {
      access: access.admin,
      title: "Delete user",
      local_tasks: [
        { name: "user.update", label: "Edit"},
        { name: "user.delete", label: "Delete"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/user.js